import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../generic/CustomBtn';

import closeImg from '../../../../assets/image/map/close-info-icon.svg';
import openImg from '../../../../assets/image/map/open-info-icon.svg';
import exclmImg from '../../../../assets/image/map/exclamation-mark.svg';
import drawPolyImg from '../../../../assets/image/map/draw-polygon.svg';

const MapInfo = ({ data, handleClick, viewType = 'nft-map', extra, shuffle = () => {} }) => {
  const translate = useIntl();
  const [isOpened, setIsOpened] = useState(true);

  if (viewType === 'nft-map') {
    if (+data.square) {
      return (
        <div className="map__calculation-box map__calculation-box__smaller">
          <div className="map__inside-block">
            <span className="map__init-title map__init-title__details">
              {translate.formatMessage({ id: 'wizardForm.step2.map.projectLocationDetails' })}
            </span>
            <span className="map__init-title">
              {translate.formatMessage({ id: 'wizardForm.step2.map.projectArea' })}
            </span>
            <span className="map__init-text">{`${data.square} ha`}</span>
            <span className="map__init-title">
              {translate.formatMessage({ id: 'wizardForm.step2.location' })}
            </span>
            <span className="map__init-text">{data.region}</span>
            <span className="map__init-title">
              {translate.formatMessage({ id: 'wizardForm.step2.codePlus' })}
            </span>
            <span className="map__init-text">{data.codePlus}</span>
            {extra.warning.cause === 'small-zone' ? (
              <span className="map__error-text"><b>{extra.warning.message}</b></span>
            ) : (
              <div className="map__btn-wrapper map__btn-wrapper__save">
                <CustomBtn label={translate.formatMessage({ id: 'button-save' })} handleClick={handleClick} />
              </div>
            )}
          </div>
        </div>
      );
    }
    return (
      <div className={`map__calculation-box ${isOpened ? '' : 'map__calculation-box__closed'}`}>
        <div
          onClick={() => setIsOpened(!isOpened)}
          className={isOpened ? 'map__closeButton' : 'map__openButton'}
        >
          {isOpened ? <img src={closeImg} alt="Close" /> : <img src={openImg} alt="Open" />}
        </div>
        <div className="map__inside-block map__init-text">
          <img src={exclmImg} alt="Exclamation" />
          {isOpened && (
            <>
              <p>
                {translate.formatMessage({ id: 'wizardForm.step2.map.description1' })}
                <img src={drawPolyImg} className="map__draw-polygon" alt="Draw polygon" />
              </p>
              <p>{translate.formatMessage({ id: 'wizardForm.step2.map.description2' })}</p>
            </>
          )}
        </div>
      </div>
    );
  }

  if (viewType === 'monitoring-map') {
    if (extra.warning.cause === 'overlap') {
      return (
        <div className="map__calculation-box map__calculation-box__smaller">
          <div className="map__inside-block">
            <span className="map__error-text"><b>{extra.warning.message}</b></span>
          </div>
        </div>
      );
    }
    if (+data.square) {
      return (
        <div className="map__calculation-box map__calculation-box__smaller">
          <div className="map__inside-block">
            <span className="map__init-title map__init-title__details">
              {translate.formatMessage({ id: 'wizardForm.step2.map.monitoringZoneDetails' })}
            </span>
            <span className="map__init-title">
              {translate.formatMessage({ id: 'wizardForm.step2.map.monitoringZoneArea' })}
            </span>
            <span className="map__init-text">
              {`${data.square} ha`}
            </span>
            <span className="map__init-title">
              {translate.formatMessage({ id: 'wizardForm.step2.location' })}
            </span>
            <span className="map__init-text">{data.region}</span>
            <span className="map__init-title">
              {translate.formatMessage({ id: 'wizardForm.step2.codePlus' })}
            </span>
            <span className="map__init-text">{data.codePlus}</span>
            {extra.warning.cause ? (
              <span className="map__error-text"><b>{extra.warning.message}</b></span>
            ) : (
              <div className="map__btn-wrapper">
                <CustomBtn
                  label={extra.useEntireZone
                    ? translate.formatMessage({ id: 'wizardForm.step2.map.save-warning' })
                    : translate.formatMessage({ id: 'button-save' })}
                  handleClick={handleClick}
                />
              </div>
            )}
          </div>
        </div>
      );
    }
    return (
      <div className={`map__calculation-box ${isOpened ? '' : 'map__calculation-box__closed'}`}>
        <div
          onClick={() => setIsOpened(!isOpened)}
          className={isOpened ? 'map__closeButton' : 'map__openButton'}
        >
          {isOpened ? <img src={closeImg} alt="Close" /> : <img src={openImg} alt="Open" />}
        </div>
        {isOpened && (
          <div className="map__inside-block map__init-text">
            <img src={exclmImg} alt="Exclamation" />
            {extra.usePreviousZone ? (
              <>
                <p>{translate.formatMessage({ id: 'wizardForm.step2.map.description3' })}</p>
                <div className="map__btn-wrapper">
                  <CustomBtn
                    label={translate.formatMessage({ id: 'button-save' })}
                    handleClick={handleClick}
                  />
                </div>
              </>
            ) : (
              <>
                <p>
                  {translate.formatMessage({ id: 'wizardForm.step2.map.description4' })}
                  <img src={drawPolyImg} className="map__draw-polygon" alt="Draw polygon" />
                </p>
                <p>{translate.formatMessage({ id: 'wizardForm.step2.map.description5' })}</p>
              </>
            )}
          </div>
        )}
        {!isOpened && <img src={exclmImg} alt="Exclamation" />}
      </div>
    );
  }

  // viewType === 'sample-map'
  return (
    <div className={`map__calculation-box map__calculation-box__smaller ${isOpened ? '' : 'map__calculation-box__closed'}`}>
      <div
        onClick={() => setIsOpened(!isOpened)}
        className={isOpened ? 'map__closeButton' : 'map__openButton'}
      >
        {isOpened ? <img src={closeImg} alt="Close" /> : <img src={openImg} alt="Open" />}
      </div>
      {isOpened && (
        <div className="map__inside-block map__init-text-sfl">
          <img src={exclmImg} alt="Exclamation" />
          <p>{translate.formatMessage({ id: 'wizardForm.step2.map.numberSampleZones' }, { numberSampleZones: data.numberSampleZones })}</p>
          <p>{translate.formatMessage({ id: 'wizardForm.step2.map.sampleZonesLimit' }, { sampleZonesLimit: data.sampleZonesLimit })}</p>
          {extra.warning.message ? (
            <span className="map__error-text"><b>{extra.warning.message}</b></span>
          ) : (
            <>
              {' '}
              <p>{translate.formatMessage({ id: 'wizardForm.step2.map.shuffle' })}</p>

              <div className="map__btn-wrapper map__btn-wrapper__save">
                <CustomBtn customClass="btn__sfl" label={translate.formatMessage({ id: 'button-shf' })} handleClick={shuffle} />
              </div>
              <p>{translate.formatMessage({ id: 'wizardForm.step2.map.save' })}</p>
              <div className="map__btn-wrapper map__btn-wrapper__save">
                <CustomBtn label={translate.formatMessage({ id: 'button-save' })} handleClick={handleClick} />
              </div>
            </>
          )}
        </div>
      )}
      {!isOpened && <img src={exclmImg} alt="Exclamation" />}
    </div>
  );
};

export default MapInfo;
